import React from "react";
import { injectIntl } from "react-intl";
import PropTypes from "prop-types";

/**
 * Renders a checkbox and text box for enabling and setting the radius on weather searches
 */
function RadiusInput({
  disabled,
  on,
  value,
  onRadiusShowChanged,
  onRadiusValueChanged,
  intl
}) {
  const radiusTextInputDisabled = on && !disabled ? "" : "disabled";
  const radiusCheckBoxTitle = disabled
    ? intl.formatMessage({ id: "querying_polygon_warning" })
    : "";

  return (
    <div className="radius-input">
      <label htmlFor="radius-toggle">
        <input
          type="checkbox"
          id="radius-toggle"
          onChange={onRadiusShowChanged}
          checked={on}
          disabled={disabled}
          title={radiusCheckBoxTitle}
        />
        <span title={radiusCheckBoxTitle}>
          {intl.formatMessage({ id: "toggle_radius" })}
        </span>
      </label>
      <input
        id="radius-value"
        onChange={onRadiusValueChanged}
        value={value}
        placeholder={intl.formatMessage({
          id: "radius_placeholder"
        })}
        type="number"
        max="999"
        min="1"
        disabled={radiusTextInputDisabled}
        title={intl.formatMessage({
          id: "radius_placeholder"
        })}
      />
    </div>
  );
}

RadiusInput.propsTypes = {
  // True if the input and check box are disabled (typically because user has selected a polygon to search)
  disabled: PropTypes.bool.isRequired,
  // True if the checkbox is checked
  on: PropTypes.bool.isRequired,
  // The value entered in the radius textbox
  value: PropTypes.string.isRequired,
  // Called when the radius checkbox is toggled
  onRadiusShowChanged: PropTypes.func,
  // Called when the value of the input box changes
  onRadiusValueChanged: PropTypes.func,
  intl: PropTypes.object.isRequired
};

export default injectIntl(RadiusInput);
